const ufeApi = require('services/api/ufeApi');

function unlinkBiAccount(input) {
    return ufeApi
        .makeRequest('/api/bi/unlinkAccount', {
            method: 'POST',
            body: JSON.stringify(input)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = unlinkBiAccount;
